import "../scss/style.scss";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "./piwik";
import "popper.js";
import PageMenu from "./components/pageMenu";
import AOS from "aos";
import "aos/dist/aos.css";

if (import.meta.hot) {
  import.meta.hot.accept();
}

// Initialize AOS
AOS.init({
  anchorPlacement: 'bottom-bottom', // triggers when bottom of element enters bottom of viewport
  useClassNames: true,
  initClassName: false,
  animatedClassName: 'animated',
  duration: 800,
  delay: 200,
  offset: 0, // no additional offset - wait for element to actually enter viewport
  once: false,
  disable: false,
  startEvent: 'load', // wait for load event before initializing
});

// Ensure all images are loaded before refreshing AOS
const images = document.querySelectorAll('img');
let imagesLoaded = 0;
const totalImages = images.length;

if (totalImages === 0) {
  AOS.refresh();
} else {
  images.forEach((img) => {
    if (img.complete) {
      imagesLoaded++;
      if (imagesLoaded === totalImages) {
        setTimeout(() => AOS.refresh(), 100);
      }
    } else {
      img.addEventListener('load', () => {
        imagesLoaded++;
        if (imagesLoaded === totalImages) {
          setTimeout(() => AOS.refresh(), 100);
        }
      });
    }
  });
}